<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import PartnerLevelLogoComponent from "@/components/common/PartnerLevelLogoComponent";
import PartnerLevelCountriesListComponent from "@/components/common/PartnerLevelCountriesListComponent";

const { t } = useI18n({});

const store = useStore();

const silverCountries = computed(() => store.state.partnerProfile.profileData.silverCountries);

function beforeCountriesListText() {
  const countriesCount = silverCountries.value.length;
  if (countriesCount === 1) {
    return t("sap.silver.partner.subdescription.country");
  }
  if (countriesCount === 0) {
    return t("sap.silver.partner.subdescription");
  }
  return t("sap.silver.partner.subdescription.countries");
}
</script>

<template>
  <PartnerLevelLogoComponent partnerLevelType="Silver" />
  <h4 class="HeadingMediumXXXS-size flex justify-center my-4" automation-id="profileRecognitionModal-logoText">
    {{ t("sap.silver.partner") }}
  </h4>
  <p class="mb-4" automation-id="profileRecognitionModal-descriptionCountryList">
    {{ beforeCountriesListText() }}
  </p>
  <PartnerLevelCountriesListComponent :countriesList="silverCountries" />
</template>
